import * as S from "./styles.ts";
import { useTypedSelector } from "@/redux/helpers/hooks.ts";
import UserControlDropdown from "./UserControlDropdown";
import ChevronDown from "@template/icons/ChevronDown.tsx";
import { Popup } from "@template/components";

const ProfilePicture = () => {
  const { user } = useTypedSelector((state) => state.user);
  const name = [user.name, user.last_name].join(" ");
  const initials = name
    .split(" ")
    .map((n: string) => n[0])
    .join("");
  return <S.ProfilePictureContainer>{initials}</S.ProfilePictureContainer>;
};

const UserControl = () => {
  return (
    <Popup
      popupContent={<UserControlDropdown />}
      offset={[0, 10]}
      align="end"
    >
      <S.UserControlContainer>
        <ProfilePicture />
        <S.ArrowContainer>
          <ChevronDown />
        </S.ArrowContainer>
      </S.UserControlContainer>
    </Popup>
  );
};

export default UserControl;
